var _path, _path2, _path3;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgThumbsUpCircled = function SvgThumbsUpCircled(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentcolor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm0,30A14,14,0,1,1,30,16,14,14,0,0,1,16,30Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3,16.09949A2.38663,2.38663,0,0,0,23.6,12H20.1a6.57824,6.57824,0,0,0,1.1-3.30051c0-1.6-.4-2.8-1.8-3.1-1.3-.3-1.8.1-2.1,1-.4,1-.4,2.2-.8,2.9a9.67632,9.67632,0,0,1-2.8,3.2c-.4.4-.7.7-.9.7a.85533.85533,0,0,0-.8.8v8a1.01788,1.01788,0,0,0,.7.9,24.69586,24.69586,0,0,1,3.5,1,7.73082,7.73082,0,0,0,3.3.6c2.9,0,3.3-.2,4.1-1a2.98764,2.98764,0,0,0,.6-2.3,2.3741,2.3741,0,0,0,.7-2.6,2.88424,2.88424,0,0,0,.4-2.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7,12.99954h3a.94477.94477,0,0,1,1,1v8a.94477.94477,0,0,1-1,1H7a.94477.94477,0,0,1-1-1v-8A.94477.94477,0,0,1,7,12.99954Zm1,3a1,1,0,0,0,0-2,1,1,0,0,0,0,2Z",
    fillRule: "evenodd"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgThumbsUpCircled, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/thumbsUpCircled.13cd8921.svg";
export { ForwardRef as ReactComponent };